import TranscriptsBySubjectArea from './TranscriptsBySubjectArea';
import { useTranscriptSelectionOutletContext } from '../hooks/useTranscriptSelectionOutletContext';
import { TRANSCRIPTS_CATEGORIES, XQ_SUPPORT_EMAIL } from '../../constants';
import TranscriptSelectionTable from './TranscriptSelectionTable';
import TranscriptsListIcon from '../assets/transcript-selection-list.svg';
import GenericErrorCard from '../reusable/GenericErrorCard';
import CustomButton from '../reusable/CustomButton';
import { useState } from 'react';

import './TranscriptSelectionTables.css';

interface TranscriptSelectionTablesProps {
  isSideDrawerOpen: boolean;
}

function TranscriptSelectionTables({ isSideDrawerOpen }: TranscriptSelectionTablesProps) {
  const {
    workflowStatus,
    selectedTranscriptsSummaryResponse: { selectedTranscriptsError },
  } = useTranscriptSelectionOutletContext();

  const [transcriptsError, setTranscriptsError] = useState('');
  const [transcriptsUploaded, setTranscriptsUploaded] = useState(true);

  if (selectedTranscriptsError || transcriptsError)
    return (
      <GenericErrorCard
        title="Something went wrong while loading the transcript data"
        text={
          <>
            We weren’t able to retrieve the transcript information due to a system error. Please try refreshing the
            page. If the issue continues,{' '}
            <a href={`mailto:${XQ_SUPPORT_EMAIL}`} className="link-color">
              contact support
            </a>{' '}
            for help.
          </>
        }
        imgSrc={TranscriptsListIcon}
        button={
          <CustomButton variant="primary" buttonText="Refresh page" buttonAction={() => window.location.reload()} />
        }
      />
    );

  if (!transcriptsUploaded)
    return (
      <GenericErrorCard
        title="Transcript data hasn’t been uploaded yet"
        text="You’ll see student transcript information here once your district team uploads the data. Please check back soon."
        imgSrc={TranscriptsListIcon}
      />
    );

  return (
    <div className="transcript-selection-tables-container">
      {Object.values(TRANSCRIPTS_CATEGORIES).map((category) => (
        <TranscriptSelectionTable
          key={category}
          categoryName={category}
          isSideDrawerOpen={isSideDrawerOpen}
          setTranscriptsError={setTranscriptsError}
          setTranscriptsUploaded={setTranscriptsUploaded}
        />
      ))}
      {workflowStatus === 'TRANSCRIPT_SELECTION_FINALIZED' && (
        <div className="transcript-selection-category-container transcripts-view">
          <TranscriptsBySubjectArea />
        </div>
      )}
    </div>
  );
}

export default TranscriptSelectionTables;
